module.exports = __webpack_public_path__ + "static/media/HCMM215.60d0fdb6.jpg";